// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"84":"ConfermaPrenotazione","210":"DeletePrenotazione","260":"AdminCsvDownload","443":"about","863":"RiepilogoPrenotazione"}[chunkId] || chunkId) + "." + {"84":"6ff5aacb","97":"f1313f23","210":"87d0ee94","260":"14094ff7","443":"35e1e2fb","863":"15d48bc5"}[chunkId] + ".js";
};